@if (componentPositions) {
  @if (!maximizedItem) {
    <div class="grid" (mouseup)="endDrag()" (mousemove)="onDrag($event)" #grid>
      <div class="leftcol" #leftcol>
        <div id="left-top" class="grid-area left-top" dndDropzone (dndDrop)="onDrop($event, 'left-top')">
          <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'left-top'}"></ng-container>
        </div>
        <div class="dragbar left-center-dragbar" (mousedown)="startDragging('left-center')"></div>
        <div id="left-bottom" class="grid-area left-bottom" dndDropzone (dndDrop)="onDrop($event, 'left-bottom')">
          <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'left-bottom'}"></ng-container>
        </div>
      </div>
      <div class="dragbar left-dragbar" (mousedown)="startDragging('left')"></div>
      <div id="center" class="grid-area center" dndDropzone (dndDrop)="onDrop($event, 'center')">
        <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'center', galleryTabs: ['satellite']}"></ng-container>
      </div>
      <div class="dragbar right-dragbar" (mousedown)="startDragging('right')"></div>
      <div class="rightcol" #rightcol>
        <div id="right-top" class="grid-area right-top" dndDropzone (dndDrop)="onDrop($event, 'right-top')">
          <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'right-top'}"></ng-container>
        </div>
        <div class="dragbar right-center-dragbar" (mousedown)="startDragging('right-center')"></div>
        <div id="right-bottom" class="grid-area right-bottom" dndDropzone (dndDrop)="onDrop($event, 'right-bottom')">
          <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'right-bottom'}"></ng-container>
        </div>
      </div>
      <div class="dragbar center-bottom-dragbar" (mousedown)="startDragging('center-bottom')"></div>
      <div class="center-bottom" #centerbottom>
        <div id="bottom-left" class="grid-area bottom-left" dndDropzone (dndDrop)="onDrop($event, 'bottom-left')">
          <ng-container *ngTemplateOutlet="dashboardComp; context: {position: 'bottom-left', galleryTabs: ['photos']}"></ng-container>
        </div>
      </div>
    </div>
  } @else {
    <div class="single-item-view">
      @switch (maximizedItem) {
        @case ('chart') {
          <ng-container [ngTemplateOutlet]="chart"></ng-container>
        }
        @case ('details') {
          <ng-container [ngTemplateOutlet]="details"></ng-container>
        }
        @case ('map') {
          <ng-container [ngTemplateOutlet]="map"></ng-container>
        }
        @case ('table') {
          <ng-container [ngTemplateOutlet]="table"></ng-container>
        }
        @case ('search') {
          <ng-container [ngTemplateOutlet]="search"></ng-container>
        }
        @case ('snippets') {
          <ng-container [ngTemplateOutlet]="snippets"></ng-container>
        }
        @case ('photos') {
          <ng-container [ngTemplateOutlet]="photos"></ng-container>
        }
      }
    </div>
  }
}

<ng-template #dashboardComp let-position="position" let-galleryTabs="galleryTabs">
  <ng-container class="single-item-view">
    @switch (componentPositions[position]) {
      @case ('chart') {
        <ng-container [ngTemplateOutlet]="chart"></ng-container>
      }
      @case ('details') {
        <ng-container [ngTemplateOutlet]="details"></ng-container>
      }
      @case ('map') {
        <ng-container [ngTemplateOutlet]="map"></ng-container>
      }
      @case ('table') {
        <ng-container [ngTemplateOutlet]="table"></ng-container>
      }
      @case ('search') {
        <ng-container [ngTemplateOutlet]="search"></ng-container>
      }
      @case ('snippets') {
        <ng-container [ngTemplateOutlet]="snippets" ></ng-container>
      }
      @case ('photos') {
        <ng-container [ngTemplateOutlet]="photos" ></ng-container>
      }
    }
  </ng-container>
</ng-template>


<ng-template #chart>
  <app-dashboard-item id="chart" dndDraggable="chart" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" (toggleMaximize)="toggleMaximizeItem('chart')" [maximized]="maximizedItem === 'chart'">
    <app-chart [userIsCustomer]="userIsCustomer"></app-chart>
  </app-dashboard-item>
</ng-template>

<ng-template #details>
  <app-dashboard-item id="details" dndDraggable="details" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" (toggleMaximize)="toggleMaximizeItem('details')" [maximized]="maximizedItem === 'details'">
    <app-plot-details [userIsCustomer]="userIsCustomer" [ngClass]="{'no-selection': selectedPlotIds.length === 0}"></app-plot-details>
  </app-dashboard-item>
</ng-template>

<ng-template #search>
  <app-dashboard-item id="search" dndDraggable="search" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" (toggleMaximize)="toggleMaximizeItem('search')" [maximized]="maximizedItem === 'search'">
    <app-customer-search></app-customer-search>
  </app-dashboard-item>
</ng-template>

<ng-template #map>
  <app-dashboard-item id="map" dndDraggable="map" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" (toggleMaximize)="toggleMaximizeItem('map')" [maximized]="maximizedItem === 'map'">
    <app-map [userIsCustomer]="userIsCustomer"></app-map>
  </app-dashboard-item>
</ng-template>

<ng-template #table>
  <app-dashboard-item id="table" dndDraggable="table" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" (toggleMaximize)="toggleMaximizeItem('table')" [maximized]="maximizedItem === 'table'">
    <app-plots [userIsCustomer]="userIsCustomer"></app-plots>
  </app-dashboard-item>
</ng-template>

<ng-template #snippets>
  <app-dashboard-item id="snippets" dndDraggable="snippets" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" [dndDisableIf]="userIsCustomer" (toggleMaximize)="toggleMaximizeItem('snippets')" [maximized]="maximizedItem === 'snippets'">
    <app-snippets-gallery [userIsCustomer]="userIsCustomer" ></app-snippets-gallery>
  </app-dashboard-item>
</ng-template>

<ng-template #photos>
  <app-dashboard-item id="photos" dndDraggable="photos" dndEffectAllowed="move" [dndDragImageOffsetFunction]="getDragImageOffset" [dndDisableIf]="userIsCustomer" (toggleMaximize)="toggleMaximizeItem('photos')" [maximized]="maximizedItem === 'photos'">
    <app-photos-gallery [userIsCustomer]="userIsCustomer" ></app-photos-gallery>
  </app-dashboard-item>
</ng-template>





